<template>
	<div class="capture">
		<LoadingSpinner
			v-if="isLoading"
			class="capture__loading-spinner"
		/>
		<ViewMultiFormat
			v-else
			:event-id="eventId"
			:hls-url="hlsUrl"
			:graphic-sets="graphicSets"
			:event-labels="eventLabels"
			:video-available="event.videoAvailable"
			:tag-time="tagTime"
			:is-community-cropping="false"
		/>
	</div>
</template>

<script>
import ViewMultiFormat from '@shared/Views/ViewMultiFormat.vue';
import LoadingSpinner from '@shared/components/LoadingSpinner.vue';
import ApiClient from '@videotools/js/api';

export default {
	name:       'Capture',
	components: {
		ViewMultiFormat,
		LoadingSpinner,
	},
	data() {
		return {
			isLoading:   true,
			eventId:     parseInt(this.$route.params.id),
			event:       null,
			tagTime:     null,
			hlsUrl:      null,
			graphicSets: [],
			eventLabels: [],
			eventTagId:  this.$route.query.eventTagId,
		};
	},
	mounted() {
		this.fetchEvent();
	},
	methods: {
		async fetchEvent() {
			try {
				const data = await ApiClient.getEventMultiFormat(this.eventId, this.eventTagId);
				this.event = data.event;
				this.hlsUrl = data.hlsUrl;
				this.graphicSets = data.graphicSets;
				this.eventLabels = data.event.labels?.map(label => label.name);
				this.tagTime = data.tagTime;
			} catch (error) {
				console.error(error);
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.capture {
	position: relative;
	min-height: 50vh;
	height: 100%;
}

.capture__loading-spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
